











import { Component, Vue } from "vue-property-decorator";
import router from "../../router/router";
@Component
export default class Logout extends Vue {
  // 短信验证登录
  public register() {
    this.$emit("login", 2);
  }
  // 账号密码登录
  public accout() {
    this.$emit("login", 1);
  }
}
